import React, { Component } from 'react'
import CatSleeping from '../catsleeping.png'
import CatStanding from '../catstanding.png'
import FoodBowl from '../foodbowl.png'
import FullFoodBowl from '../fullfoodbowl.png'
import Zeds from '../zeds.png'
import styles from '../SnoozeArea.module.css'

class SnoozeArea extends Component {
    constructor(){
        super();
        this.state = {
            foodBowlIsFull: false,
            catIsAsleep: true
        };
    }
    handleBowlClick = () => {
        if(document.body.classList.contains("catBiscuitsCursor")){this.fillBowl();}
    }
    fillBowl = () => {
        this.setState({
            foodBowlIsFull: true
        },this.awakenCat);
    }
    awakenCat(){
        setTimeout(() => this.setState({catIsAsleep: false}),1000);
    }
    render(){
        let food = this.state.foodBowlIsFull ? 
            <img alt="Full Food Bowl" src={FullFoodBowl} id={styles.fullFoodBowl} /> :
            <div></div>;
        let cat = this.state.catIsAsleep ?
            <React.Fragment>
                <img alt="Sleeping Cat" src={CatSleeping} id={styles.sleepingCat} />
                <img alt="Zeds" src={Zeds} id={styles.zeds} />
            </React.Fragment> :
            <img alt="Standing Cat" src={CatStanding} id={styles.standingCat} />;
        return (
            <div id="snoozeArea" className={styles.snoozeArea}>
                {cat}
                <span id={styles.safeCode}>43517</span>
                <img alt="Food Bowl" src={FoodBowl} id={styles.foodBowl} onClick={this.handleBowlClick} />
                {food}
            </div>
        )
    }
}

export default SnoozeArea